import {
  attr,
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
} from '@microsoft/fast-element';
import { AnalyticsWizardTemplate as template } from './analytics-wizard.template';
import { AnalyticsWizardStyles as styles } from './analytics-wizard.styles';
import { IBuyerAnalyticsService } from '../../../../services';

const name = 'analytics-wizard';

@customElement({
  name,
  template,
  styles,
})
export class AnalyticsWizard extends FASTElement {
  @IBuyerAnalyticsService buyerAnalyticsService: IBuyerAnalyticsService;
  @observable currentStep: 1 | 2 | 3 = 1;

  private notifier1: any;
  private handler1: any;

  connectedCallback(): void {
    super.connectedCallback();
    this.currentStep = this.buyerAnalyticsService.currentStep
    this.loadCurrentStep();
  }

  private loadCurrentStep() {
    const context = this;
    this.notifier1 = Observable.getNotifier(this.buyerAnalyticsService);
    this.handler1 = {
      handleChange(source: any, splices: Splice[]) {
        context.currentStep = source.currentStep;
      },
    };

    this.notifier1.subscribe(this.handler1, 'currentStep');
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.notifier1.unsubscribe(this.handler1);
  }

  public changeStep(step: 1 | 2 | 3) {
    if (this.buyerAnalyticsService.currentStep !== 1) {
      this.buyerAnalyticsService.currentStep = step;
    }
  }

  public clearOptions() {
      this.buyerAnalyticsService.resetSelectedOptions()
  }
}
